module.exports = __webpack_public_path__ + "static/media/logo_DECEA_text.d09966b6.png";